export enum NotificationType {
  ERROR,
  INFO,
  SUCCESS
}
